import { MerchandisingProgramCategoryTypeEnumValue } from 'enums/MerchandisingProgramCategoryTypeEnum';

export const getLocalizedCategoryLabel = (category, isFrench = false) => {
  if (!category) {
    return '';
  }

  if (isFrench) {
    return category.nameFr || category.nameEn || category.internalName || category.id || '';
  }

  return category.nameEn || category.nameFr || category.internalName || category.id || '';
};

export const getMerchandisingCategoryKind = category => {
  switch (Number(category?.categoryType)) {
    case MerchandisingProgramCategoryTypeEnumValue.QuarterlyVisits:
      return 'quarterly';
    case MerchandisingProgramCategoryTypeEnumValue.TrainStaff:
      return 'trainStaff';
    case MerchandisingProgramCategoryTypeEnumValue.SeasonalChange:
      return 'seasonal';
    default:
      return 'unknown';
  }
};

export const isLimitedExteriorSignageCategory = category => {
  return Boolean(category?.allowMultipleQuantity);
};
